/**
 *    @author:
 *    @since:
 *
 */

 import { ViewportScroller } from '@angular/common';
import { Util } from 'src/refresh/service/Util';
 import { IValidator } from '../_common/component/IValidator';
 import { ChildDeceasedComponent } from './child-deceased/child-deceased.component';
 import { Setup2Component} from './setup_2.component';
 
 export class Setup2Validation extends IValidator {
 
      constructor(private component: Setup2Component,private childDeceased:ChildDeceasedComponent,private menuID:number) {
            super();
            this.isChildDeceased = this.component.data.aboutChild.isChildDeceased;
            this.isUnableToCertify = this.component.data.eligibility.isUnableToCertify;
            this.viewportScroller = this.component.viewportScroller;
      }
      
      private isChildDeceased:string;
      private isUnableToCertify:string; 
      private viewportScroller:ViewportScroller;
 
      private success: boolean;
 
      public validate(): boolean {
 
           this.success = true;
 
           if(Util.isEmpty(this.component.data.eligibility.isUnableToCertify)){
                this.focus("isUnableToCertify","radio_isUnableToCertifyRadio_0").error_isUnableToCertify = "setup_2.emptyIsUnableToCertify";
           }
 
           return this.childDeceased.validate() && this.success;
      }

      public IdOfChanged():number { 

            if (  this.isChildDeceased !=  this.component.data.aboutChild.isChildDeceased ||
                  this.isUnableToCertify !=  this.component.data.eligibility.isUnableToCertify) return this.menuID;

              return 0;
       }

       private focus(tagId:string,ctrlId:string) : Setup2Component {
            if ( this.success ) {
                 this.viewportScroller.scrollToAnchor(tagId);
                 let ctrl = document.getElementById(ctrlId);
                 ///console.log(ctrl);
                 if ( ctrl ) ctrl.focus();
            }
                 
            this.success = false;
            return this.component;
       }

 }
 
 